import { harryMediaArray } from './harryMedia'
import { harryBio } from './harryBios'
import { hermioneProfileReviewHinge, dumbledoreProfileReviewBumble, ronProfileReviewTinder } from './harryProfileReviews'

export const harryDatingProfileHinge = {
  _id: 'harryDatingProfileHingeId',
  userId: 'harryUserId',
  email: 'harry@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: harryMediaArray[4]._id,
      mediaItemURL: harryMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[4].type,
      caption: harryMediaArray[4].captions[2],
      subcaption: harryMediaArray[4].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[3]._id,
      mediaItemURL: harryMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[3].type,
      caption: harryMediaArray[3].captions[1],
      subcaption: harryMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[1]._id,
      mediaItemURL: harryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[1].type,
      caption: harryMediaArray[1].captions[2],
      subcaption: harryMediaArray[1].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[10]._id,
      mediaItemURL: harryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[10].type,
      caption: harryMediaArray[10].captions[0],
      subcaption: harryMediaArray[10].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[14]._id,
      mediaItemURL: harryMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[14].type,
      caption: harryMediaArray[14].captions[1],
      subcaption: harryMediaArray[14].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[15]._id,
      mediaItemURL: harryMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[15].type,
      caption: harryMediaArray[15].captions[0],
      subcaption: harryMediaArray[15].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: harryBio._id,
    vitalInfo: { ...harryBio.vitalInfo },
    prompts: [
      { ...harryBio.prompts[0] },
      { ...harryBio.prompts[1] },
      { ...harryBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...hermioneProfileReviewHinge }
  ],
  mediaItems: [ ...harryMediaArray ],
  bioItems: { ...harryBio },
}

export const harryDatingProfileBumble = {
  _id: 'harryDatingProfileBumbleId',
  userId: 'harryUserId',
  email: 'harry@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: harryMediaArray[4]._id,
      mediaItemURL: harryMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[4].type,
      caption: harryMediaArray[4].captions[2],
      subcaption: harryMediaArray[4].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[3]._id,
      mediaItemURL: harryMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[3].type,
      caption: harryMediaArray[3].captions[1],
      subcaption: harryMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[1]._id,
      mediaItemURL: harryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[1].type,
      caption: harryMediaArray[1].captions[2],
      subcaption: harryMediaArray[1].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[10]._id,
      mediaItemURL: harryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[10].type,
      caption: harryMediaArray[10].captions[0],
      subcaption: harryMediaArray[10].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[14]._id,
      mediaItemURL: harryMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[14].type,
      caption: harryMediaArray[14].captions[1],
      subcaption: harryMediaArray[14].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[15]._id,
      mediaItemURL: harryMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[15].type,
      caption: harryMediaArray[15].captions[0],
      subcaption: harryMediaArray[15].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: harryBio._id,
    vitalInfo: { ...harryBio.vitalInfo },
    prompts: [
      { ...harryBio.prompts[0] },
      { ...harryBio.prompts[1] },
      { ...harryBio.prompts[2] }
    ],
    aboutMe: harryBio.aboutMe[0],
    hobbies: [harryBio.hobbies[0], harryBio.hobbies[1], harryBio.hobbies[2], harryBio.hobbies[3], harryBio.hobbies[4] ],
  },
  profileReviews: [
    { ...dumbledoreProfileReviewBumble }
  ],
  mediaItems: [ ...harryMediaArray ],
  bioItems: { ...harryBio },
}

export const harryDatingProfileTinder = {
  _id: 'harryDatingProfileTinderId',
  userId: 'harryUserId',
  email: 'harry@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: harryMediaArray[4]._id,
      mediaItemURL: harryMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[4].type,
      caption: harryMediaArray[4].captions[2],
      subcaption: harryMediaArray[4].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[3]._id,
      mediaItemURL: harryMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[3].type,
      caption: harryMediaArray[3].captions[1],
      subcaption: harryMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[1]._id,
      mediaItemURL: harryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[1].type,
      caption: harryMediaArray[1].captions[2],
      subcaption: harryMediaArray[1].subcaptions[2],
    },
    {
      mediaItemId: harryMediaArray[10]._id,
      mediaItemURL: harryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[10].type,
      caption: harryMediaArray[10].captions[0],
      subcaption: harryMediaArray[10].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[14]._id,
      mediaItemURL: harryMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[14].type,
      caption: harryMediaArray[14].captions[1],
      subcaption: harryMediaArray[14].subcaptions[1],
    },
    {
      mediaItemId: harryMediaArray[15]._id,
      mediaItemURL: harryMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: harryMediaArray[15].type,
      caption: harryMediaArray[15].captions[0],
      subcaption: harryMediaArray[15].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: harryBio._id,
    vitalInfo: { ...harryBio.vitalInfo },
    prompts: [
      { ...harryBio.prompts[0] },
      { ...harryBio.prompts[1] },
      { ...harryBio.prompts[2] }
    ],
    aboutMe: harryBio.aboutMe[0],
    hobbies: [harryBio.hobbies[0], harryBio.hobbies[1], harryBio.hobbies[2], harryBio.hobbies[3], harryBio.hobbies[4] ],
  },
  profileReviews: [
    { ...ronProfileReviewTinder }
  ],
  mediaItems: [ ...harryMediaArray ],
  bioItems: { ...harryBio },
}